import * as S from './BestPlaceSection.styles'

type StatItem = {
  value: string
  caption: string
}

type Props = {
  title: string
  stats: StatItem[]
}

export default function BestPlaceSection({ title, stats }: Props) {
  return (
    <S.Section data-testid="multi-product-best-place">
      <S.Title>{title}</S.Title>
      <S.Stats>
        {stats.map((stat, index) => (
          <S.Stat key={index} data-testid={`best-place-stat-${index}`}>
            <S.Laurel />
            <S.StatText>
              <S.StatValue>{stat.value}</S.StatValue>
              <S.StatCaption>{stat.caption}</S.StatCaption>
            </S.StatText>
            <S.LaurelRight />
          </S.Stat>
        ))}
      </S.Stats>
    </S.Section>
  )
}
